import React from "react";
import CIcon from "@coreui/icons-react";

export default [
  {
    _tag: "CSidebarNavItem",
    name: "Authentication",
    to: "/authentication",
    icon: <i className="far fa-user c-sidebar-nav-icon"></i>,

  },
  // {
  //   _tag: "CSidebarNavItem",
  //   name: "Dashboard",
  //   to: "/dashboard",
  //   icon: <i class="far fa-chart-bar c-sidebar-nav-icon"></i>,
  //   // badge: {
  //   //   color: "info",
  //   //   text: "NEW",
  //   // },
  // }, 
  {
    _tag: "CSidebarNavItem",
    name: "GSTR-1",
    to: "/gstr-1",
    icon: "cil-book",
  },
  {
    _tag: "CSidebarNavItem",
    name: "GSTR-3B",
    to: "/gstr-3b",
    icon: "cil-book",
  },
  {
    _tag: "CSidebarNavItem",
    name: "GSTR-2A",
    to: "/gstr-2a",
    icon: "cil-book",
  },
  {
    _tag: "CSidebarNavItem",
    name: "GSTR-2B",
    to: "/gstr-2b",
    icon: "cil-book",
  },
  {
    _tag: "CSidebarNavItem",
    name: "Reports",
    to: "/Reports",
    icon: <i class="far fa-file-alt c-sidebar-nav-icon"></i>,
  },
  
];
